<template>
  <div id="Start" style="height:calc(100vh);" class="col-12 t-c-v" :class="$store.state.app_type">
    <div class="col-12 t-c">
        <img src="../assets/logo_t.png" class="w15 r5">
        <div class="col-12">
            <img src="../assets/loading.gif" class="w5">
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Start',
  data () {
    return {
    }
  },
  created: function () {
    //console.log(this.$parent)
    let app_arr = ['Technician', 'Agent', 'User'];
    let app_type = localStorage.getItem('app_type');
    let _this = this;
    if(app_type && app_arr.indexOf(app_type) !== -1){
      _this.$store.commit('setApp',app_type);
    }else{
      _this.$store.commit('setApp','Technician');
    }
    setTimeout(function() {
       // _this.$router.push({path: '/'});
       // _this.$router.go(0);
        console.log(_this.$store.state.app_type)
        _this.$router.push({name: _this.$store.state.app_type});
    }, 500);
  },
  beforeCreate(){
    document.me
  }
}
</script>
<style scoped>
.Agent{
	background-color: #b0941e
}
.Technician{
    background-color: #0267D1
}
</style>


// WEBPACK FOOTER //
// src/components/Start.vue